<template>
  <div class="cmp-booking-requests-request_list dt-page">
    <div class="dt-page--data-table">
      <NTable
        class="booking-requests-request_list h1"
        :items="bookingRequests"
        :headers="headers"
        :loadingFlag="loadingFlag"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            @click="onBookingRequestRowClicked(item)"
            class="booking-request-row"
          >
            <td v-bind="tdcon('booking')">
              <span>{{ item["booking_start_date"] }}</span>
            </td>
            <td v-bind="tdcon('artist')">
              <span>{{ item["artist_info"] }}</span>
              <!-- <InfoCard
                :label="item['artist_info'] || ''"
                :infoString="item['artist_info'] || ''"
              /> -->
            </td>
            <td v-bind="tdcon('contact')">
              <span>
                {{ contactValue(item) }}
                <!-- {{  item["contact_first_name"] }}-->
              </span>
              <!-- <InfoCard
                :label="contactValue(item) || ''"
                :infoString="contactValue(item) || ''"
              /> -->
            </td>
            <td v-bind="tdcon('venue')">
              <span>{{ venueValue(item) }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <div class="dt-icon-container">
                <img
                  @click.stop="(e) => deleteRequest(item)"
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s2"
                />
              </div>
            </td>
          </tr>

          <!-- <tr @click="onRowClicked(item.external_id)">
          <td :class="['start_date']">{{item['start_date']}}</td>
          <td :class="['name_group']">{{item['name_group']}}</td>
          <td :class="['city']">{{ item.city + ', ' + item.iso2 }}</td>
        </tr> -->
        </template>
      </NTable>

      <!-- <v-data-table
        :headers="headers"
        :items="bookingRequests"
        hide-actions
        class="dt-table request-table elevation-1"
      >
        <template slot="items" slot-scope="props">
          <tr 
            @click="onBookingRequestRowClicked(props.item)"
            class="booking-request-row"
          >
            <td class="start_date"> {{props.item['booking_start_date']}} </td>
            <td>{{props.item['artist_info']}}</td>
            <td>{{ props.item['contact_first_name'] + ' ' + props.item['contact_last_name'] + "\n" + props.item['promoter_company_name'] +"\n"+ props.item['contact_email1'] }}</td>
            <td> {{venueValue(props.item)}} </td>
            <td>
              <div class="delete-button">
                <img 
                  src="static/icons/delete.svg" 
                  @click.stop="e => deleteRequest(props.item)" 
                  class="dt-icon" 
                  alt=""
                >
              </div>
            </td>
          </tr>
        </template>
      </v-data-table> -->
    </div>

    <v-dialog v-model="bookingRequestWizardDialog" width="800">
      <BookingRequestWizard
        :calendar-date-id="calendarDateIdSelectd"
        :selected-request="selectedRequest"
        :selected-item="selectedItem"
        @cancelled="onBookingRequestWizardCancel"
      />
    </v-dialog>
  </div>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../store/types";
import BookingRequestWizard from "../components/booking-request-wizard";
import { bookingRequestsWizardRouterName } from "../../../router/functions";
import InfoCard from "../../../dt-plugins/info-card/info-card.vue";

import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../plugins/datatable";

export default {
  components: {
    BookingRequestWizard,
    NTable,
    InfoCard,
  },
  data: function () {
    return {
      calendarDateIdSelectd: 0,
      selectedRequest: {},
      selectedItem: {},
      bookingRequestWizardDialog: false,

      loadingFlag: false,
    };
  },
  mounted: function () {
    this.fetchList();
  },
  computed: {
    ...mapGetters(storeNS, {
      bookingRequests: "bookingRequests",
    }),
    headers: function () {
      return [
        createTableHeader("booking", {
          text: `${this.$t("booking")} ${this.$t("artist")}`,
          f: 0.5,
          fw: 700,
        }),
        createTableHeader("artist", {
          text: `${this.$t("artist")} ${this.$t("info")}`,
        }),
        createTableHeader("contact", {
          text: `${this.$t("contact")}`,
        }),
        createTableHeader("venue", {
          text: `${this.$t("venue")}`,
        }),
        createTableHeader("options", { text: false, mw: 40 }),
      ];
    },
  },
  watch: {},
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.GET_BOOKING_REQUESTS]: ActionTypes.GET_BOOKING_REQUESTS,
      [ActionTypes.DELETE_BOOKING_REQUEST]: ActionTypes.DELETE_BOOKING_REQUEST,
    }),

    async fetchList() {
      this.loadingFlag = true;
      await this[ActionTypes.GET_BOOKING_REQUESTS]();
      this.loadingFlag = false;
    },

    deleteRequest(item) {
      this[ActionTypes.DELETE_BOOKING_REQUEST](item.calendar_date_id);
    },

    // onRowClicked(calendar_date_id) {
    //   this.$router.push({
    //     path: "/booking/booking_list/" + calendar_date_id + "/overview"
    //   });
    // },

    onBookingRequestWizardCancel() {
      this.bookingRequestWizardDialog = false;
    },

    onBookingRequestRowClicked(item) {
      // this.calendarDateIdSelectd = item["calendar_date_id"];
      // this.selectedItem = item;
      // this.bookingRequestWizardDialog = true;

      // console.log(item);
      this.$router.push({
        name: bookingRequestsWizardRouterName,
        params: {
          calendar_date_id: item.calendar_date_id,
        },
        query: {
          artist_id: item.artist_id,
        },
      });
    },
    venueValue: function (request) {
      return `${request["venue_name"] ? request["venue_name"] : ""} ${
        request["venue_city"] ? "\n" + request["venue_city"] : ""
      }  ${request["venue_country"] ? "\n" + request["venue_country"] : ""}`;
    },
    contactValue: function (item) {
      return (
        item["contact_first_name"] +
        " " +
        item["contact_last_name"] +
        "\n" +
        item["promoter_company_name"] +
        "\n" +
        item["contact_email1"]
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp-booking-requests-request_list {
  .dt-ntable {
    --ntable-height: calc(100vh - 100px);
    th:first-child {
      /* text-transform: capitalize; */
    }
    // th:nth-child(3),
    // td:nth-child(3) {
    //   flex: 0.4;
    // }
    td:nth-child(2),
    td:nth-child(3),
    td:nth-child(4) {
      white-space: pre-wrap;
      span {
        text-align: left;
        white-space: pre-line;
      }
    }
    tr {
      height: auto !important;
      min-height: auto !important;
    }
  }
}

// .dt-table {
//   --rest-cell-padding: 0px 5px;
//   // --tb-layout: fixed;

//   --tbody-overflow: auto;
//   --tbody-max-height: calc( 100vh - 85px);

//   .table__overflow {
//     background: lightcoral;
//   }

//   table {
//     th:nth-child(5) {
//       width: 28px !important;
//       max-width: 28px !important;
//     }
//   }
// }

// .request-table {
//   td.start_date {
//     color: black !important;
//     font-weight: 800 !important;
//   }
// }
</style>
